import Checkbox from '../Checkbox';
import { StyledAutoCompleteListOption } from './AutoCompleteList.style';

const AutoCompleteListOption = ({
  option,
  isChecked,
  isDisabled,
  isIndeterminate = false,
  onChange
}) => {
  const { render, displayValue } = option;
  const optionInView = typeof render === 'function' ? render() : displayValue;
  return (
    <StyledAutoCompleteListOption>
      <Checkbox
        data-cy={option.value}
        checked={!!isChecked}
        disabled={!!isDisabled}
        indeterminate={!!isIndeterminate}
        onChange={e => onChange(e, option)}
      />
      {optionInView}
    </StyledAutoCompleteListOption>
  );
};

export default AutoCompleteListOption;
